import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateNewPriceCategory extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("PriceCategory/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class UpdateAPriceCategory extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("PriceCategory/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetASinglePriceCategory extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("PriceCategory/GetById");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetAllPriceCategories extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("PriceCategory/GetList");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class DeleteAPriceCategory extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("PriceCategory/Delete");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetLitePriceCategories extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("PriceCategory/GetLightList");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class AddUserToPriceCategory extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("PriceCategory/AddUsers");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetPriceCategoryUsers extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("PriceCategory/GetUsers");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class TogglePriceCategoryIsShow extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("PriceCategory/ChangePriceCategoryIsShow");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export {
  CreateNewPriceCategory,
  UpdateAPriceCategory,
  GetASinglePriceCategory,
  GetAllPriceCategories,
  DeleteAPriceCategory,
  GetLitePriceCategories,
  AddUserToPriceCategory,
  GetPriceCategoryUsers,
  TogglePriceCategoryIsShow,
};
